import apiV2 from '.'

export const conferencesV2Api = apiV2.injectEndpoints({
  endpoints: builder => ({
    getConferences: builder.query({
      query: ({ domainId, eventId, userId }) => `/domains/${domainId}/events/${eventId}/conferences/v2/users/${userId}`,
      transformResponse: response => response.data.conferences,
      providesTags: ['CONFERENCES_V2', 'CATEGORIES_MODELS'],
    }),
    setConferenceParticipation: builder.mutation({
      query: ({ domainId, eventId, userId, slotId }) => ({
        url: `/domains/${domainId}/events/${eventId}/conferences/v2/users/${userId}/slots/${slotId}`,
        method: 'PUT',
      }),
      invalidatesTags: ['CONFERENCES_V2'],
    }),
  }),
})

export const { useGetConferencesQuery, useSetConferenceParticipationMutation } = conferencesV2Api
